import { render, staticRenderFns } from "./DocumentAndPdfTypeSlot.vue?vue&type=template&id=46c9b4c4&scoped=true"
import script from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
export * from "./DocumentAndPdfTypeSlot.vue?vue&type=script&lang=ts"
import style0 from "./DocumentAndPdfTypeSlot.vue?vue&type=style&index=0&id=46c9b4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c9b4c4",
  null
  
)

export default component.exports